import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { action, observable } from 'mobx';
import DataTable from '../DataTable';

@inject('requestStore')
@observer
class RequestDetailRequestErrorList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
    requestStore: PropTypes.object.isRequired,
  }

  componentWillMount() { this.reset(); }

  @action reset() {
    const { params: { id }, requestStore } = this.props;
    this.request = requestStore.findById(id);
  }

  @observable request = {
    raw_data: [],
  };
  slug = '/request';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'error', label: 'Error' },
  ];

  render() {
    const requestErrors = (this.request && this.request.request_errors) || [];
    return (
      <DataTable
        data={requestErrors}
        slug={this.slug}
        columns={this.columns}
        readOnly paginate
      />
    );
  }
}

export default RequestDetailRequestErrorList;



// WEBPACK FOOTER //
// ./src/components/Request/RequestDetailRequestErrorList.js